import "./Ways.css"
import React from "react"
export default function WayList(props) {
    let xc
    return props.ModuleDetails.map((md, index) => {
            {xc = "tel:" + md.Subtitle}

        return<div className="line">
            <a
                className="number"
                href={xc}
                style={{ backgroundColor: md.BackgroundColor, color: md.SubTitleForeColor }}
                key={index}
            >
                {md.Subtitle}
            </a>
            <span className="dot"></span>
            <div className="n&img">
                <span className="name">
                    <span className="twopoint" style={{ backgroundColor: md.BackgroundColor, color: md.TitleForeColor }}>:</span>
                    {md.Title}
                </span>
                <span className="imagewaylitt">
                    <img
                        src={md.ImageURL}
                        alt={md.ImageAlt}
                    />
                </span>
            </div>
        </div>
    })
}